import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import signinReducer from "./reducers/signin";
import signupReducer from "./reducers/signup";
import rfqReducer from "./reducers/rfq";
import approvalReducer from "./reducers/approval";
import purchaseOrderReducer from "./reducers/purchaseOrder";
import quoteReducer from "./reducers/quote";
import configurationReducer from "./reducers/configuration";
import settingsReducer from "./reducers/settings";
import commonReducer from "./reducers/common";
import partyReducer from "./reducers/party";
import contentReducer from "./reducers/content";
import profileReducer from "./reducers/profile";
import grnReducer from "./reducers/grn";
import notificationReducer from "./reducers/notification";
import communicationReducer from "./reducers/communication";
import reportingReducer from "./reducers/reporting";
import forgotPasswordReducer from "./reducers/forgotPassword";
import repeatOrderReducer from "./reducers/repeatOrder";
import commsReducer from "./reducers/comms";
import facilityReducer from "./reducers/facility";
import inventoryReducer from "./reducers/inventory";
import productReducer from "./reducers/product";
import paymentReducer from "./reducers/payment";
import dashboardReducer from "./reducers/dashboard";
import paymentInvoiceReducer from "./reducers/invoice";
import discoveryAgentReducer from "./reducers/discoveryAgent";
import rateContractReducer from "./reducers/rateContract";
import oauthReducer from "./reducers/oauth";
import browserReducer from "./reducers/browserConfig";
import proformaInvoiceReducer from "./reducers/proformaInvoice";

const reducers = combineReducers({
  login: signinReducer,
  signup: signupReducer,
  rfq: rfqReducer,
  order: purchaseOrderReducer,
  approval: approvalReducer,
  quote: quoteReducer,
  configuration: configurationReducer,
  settings: settingsReducer,
  common: commonReducer,
  party: partyReducer,
  content: contentReducer,
  profile: profileReducer,
  grn: grnReducer,
  notification: notificationReducer,
  communication: communicationReducer,
  reporting: reportingReducer,
  forgotPassword: forgotPasswordReducer,
  repeatOrder: repeatOrderReducer,
  comms: commsReducer,
  facility: facilityReducer,
  inventory: inventoryReducer,
  product: productReducer,
  payment: paymentReducer,
  dashboard: dashboardReducer,
  paymentInvoice: paymentInvoiceReducer,
  discoveryAgent: discoveryAgentReducer,
  rateContract: rateContractReducer,
  oauth: oauthReducer,
  browserConfig: browserReducer,
  proformaInvoice: proformaInvoiceReducer
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["login", "party", "dashboard", "oauth"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export default store;

export const resetAllStoreStates = () => {
  // console.log("Calling reset all redux store states");
  store.dispatch({ type: "RESET_ALL" });
};
